// PaymentForm.js
import React, { useState } from 'react';
import {
	useStripe,
	useElements,
	PaymentElement,
} from '@stripe/react-stripe-js';
import { Box, Button, Flex, useToast } from '@chakra-ui/react';

const PaymentForm = ({
	amount,
	currency = 'GBP',
	onSuccess,
	buttonText,
	mode = 'payment',
}) => {
	const stripe = useStripe();
	const elements = useElements();
	const toast = useToast();
	const [isProcessing, setIsProcessing] = useState(false);

	const handlePaymentSubmit = async (e) => {
		e.preventDefault();

		if (!stripe || !elements) {
			console.error('Stripe.js has not loaded yet.');
			return;
		}

		setIsProcessing(true);

		if (mode === 'setup') {
			const { error, setupIntent } = await stripe.confirmSetup({
				elements,
				confirmParams: {},
				redirect: 'if_required',
			});

			if (error) {
				console.error('Error confirming setup:', error.message);
				toast({
					title: 'Payment Error',
					description: error.message,
					status: 'error',
					duration: 3000,
					isClosable: true,
				});
				setIsProcessing(false);
				return;
			}

			if (setupIntent && setupIntent.status === 'succeeded') {
				if (onSuccess) {
					onSuccess(setupIntent);
				}
			}

			setIsProcessing(false);
			return;
		}

		const { error, paymentIntent } = await stripe.confirmPayment({
			elements,
			confirmParams: {
				// Remove the return_url to prevent redirect
				// return_url: `${window.location.origin}/payment-success`,
			},
			redirect: 'if_required', // Only redirect if required by the payment method
		});

		if (error) {
			console.error('Error confirming payment:', error.message);
			toast({
				title: 'Payment Error',
				description: error.message,
				status: 'error',
				duration: 3000,
				isClosable: true,
			});
			setIsProcessing(false);
			return;
		}

		// Check if payment was successful
		if (paymentIntent && paymentIntent.status === 'succeeded') {
			// Call the success callback instead of showing toast
			if (onSuccess) {
				onSuccess(paymentIntent);
			} else {
				toast({
					title: 'Payment Successful',
					description: 'Payment completed successfully!',
					status: 'success',
					duration: 3000,
					isClosable: true,
				});
			}
		}

		setIsProcessing(false);
	};

	return (
		<Box as='form' onSubmit={handlePaymentSubmit} w='100%' p={6}>
			<PaymentElement />
			<Flex justify='flex-end'>
				<Button
					colorScheme='teal'
					type='submit'
					isLoading={isProcessing}
					isDisabled={!stripe || !elements || isProcessing}
					mt={6}
					px={8}
					py={6}
					fontSize='lg'
					fontWeight='bold'>
					{isProcessing ? 'Processing...' : buttonText || `Pay £${amount}`}
				</Button>
			</Flex>
		</Box>
	);
};

export default PaymentForm;
